import { useParams } from 'react-router-dom'
import useSWR from 'swr'
import SetComponent from './SetComponent'
import { useRole } from '@/hooks/auth'
import { Role } from '@/constants/role'

const UPDATE_KEY = 'pamReadable'

const SetPamReadable = () => {
  const { id } = useParams('')
  const { data: user } = useSWR([`/users/${id}/full`])

  const isRevenuerLeader = useRole(Role.RevenuerLeader)
  if (!isRevenuerLeader) return null

  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-muted-foreground">
        按产品和国家开通 PAM 数据查看与导出，不授予 Mediation A/B 或 PAM Create 权限。
      </p>
      <SetComponent user={user} updateKey={UPDATE_KEY} />
    </div>
  )
}

export default SetPamReadable
